
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/groups",
      function () {
        return require("private-next-pages/community/groups/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/groups"])
      });
    }
  